import type { ReactNode } from "react";
import { useAuth } from "../../hooks/useAuth";

export function ManagerScope({ children }: { children: ReactNode }) {
  const { isOrgManager } = useAuth();
  if (!isOrgManager) return null;
  return <>{children}</>;
}
